<template>
    <div id="discounts-create-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1 class="page-title">Add Business</h1>

                <DiscountsForm :formData="formData" @formSubmitted="formSubmitted" />
            </section>
        </div>
    </div>
</template>

<script>
import DiscountsForm from '@/components/forms/DiscountsForm.vue'
const endpoint = process.env.VUE_APP_API_BASE + 'admin/discounts'

export default {
    name: 'DiscountsCreate',
    components: {
        DiscountsForm
    },
    data: function() {
        return {
            formData: {
                name: '',
                address: '',
                discount: 0,
                category: '',
                city: {
                    name: '',
                    country_code: 'ro',
                    code: ''
                },
                featured: false
            }
        }
    },
    methods: {
        formSubmitted(finalData) {
            this.axios.post(endpoint + '/create', finalData)
                .then(response => {
                    if (response.data.result == 'success') {
                        alert('success')
                        this.$router.push('/discounts')
                    }
                    else {
                        alert(response.data.message)
                    }
                }).catch(error => {
                    alert('Error occurred')
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
